export { fetchRecommendations } from '../../phoenix/data/recommendations';
